import React, { useState } from 'react';
import { useAccount } from 'wagmi';
import { getAllJoinRequestsForTeam } from '../../web3/SFM-TeamsUtils';
import PromptLogin from '../PromptLogin';
import JoiningRequestSingle from './joiningRequestSingle';
import Loader from '../../components/Loader/loader';
import { useTeam } from '../../contexts/TeamContext';

function JoiningRequests({ teamId }) {
  const { isConnected, address } = useAccount();
  const [allTeams, setAllTeams] = useState();
  const { setIsTeamchanged, isTeamchanged } = useTeam();
  const getTeams = React.useCallback(async () => {
    const teams = await getAllJoinRequestsForTeam(teamId);
    teams && setAllTeams(teams);
  }, [isConnected, address]);

  React.useEffect(() => {
    isConnected && getTeams();
  }, [getTeams]);

  const modifyUpdatesState = async () => {
    setIsTeamchanged(!isTeamchanged);
    setAllTeams();
    await getTeams();
  };
  return (
    <div className="community-area primary-bg pt-120 pb-175">
      <div className="container">
        {isConnected ? (
          <div className="row">
            <div className="col-lg-12">
              <div className="community-wrap">
                <div className="table-responsive-xl">
                  {allTeams ? (
                    allTeams.length > 0 ? (
                      allTeams.map((item) => (
                        <JoiningRequestSingle
                          teamId={teamId}
                          player={item}
                          callSaveSucceed={() => modifyUpdatesState()}
                        />
                      ))
                    ) : (
                      <h4 className="text-center  text-dark">
                        No Requests Yet
                      </h4>
                    )
                  ) : (
                    <div className="row justify-content-center">
                      <Loader />
                    </div>
                  )}{' '}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <PromptLogin />
        )}
      </div>
    </div>
  );
}

export default JoiningRequests;
